import { getExportCallLogs } from '@/services/call-log-service/call-log-service';
import { CallLogFilters, CallLogParams } from '@/services/call-log-service/call-log-service.types';
import { useState } from 'react';

interface UseExportCallLogsProps {
  filtersParams: CallLogFilters;
  paginationParams: CallLogParams;
}
export const useExportCallLogs = ({ filtersParams, paginationParams }: UseExportCallLogsProps) => {
  const [isPending, setIsPending] = useState(false);

  const exportCallLogs = async () => {
    setIsPending(true);
    const data = await getExportCallLogs({ ...filtersParams, ...paginationParams });
    setIsPending(false);
    return data;
  };

  return { exportCallLogs, isPending };
};
